import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";
import { useStoreState } from "atoms/storeAtom";

import { GetStoresParams } from "../types";

import { getStores, deleteStore } from "./index";

export const useGetStores = (
  params: GetStoresParams,
  options?:
    | Omit<UseQueryOptions<any, any, any, any>, "queryKey" | "queryFn">
    | undefined
) => {
  return useQuery(
    ["get-stores", { ...params }],
    () => getStores(params),
    options
  );
};

export const useDeleteStore = () => {
  const queryClient = useQueryClient();
  const { setStoreState } = useStoreState();

  return useMutation(["delete-stores"], deleteStore, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-stores"] });
      setStoreState({ activeItem: null });
    },
  });
};
